module.exports = __webpack_public_path__ + "img/box4-img3.3c583518.png";